import { setupLastSrpUrlActivityListeners } from '~/composables/lastSrpUrl/activityListeners';

export default defineNuxtPlugin(() => {
	setupLastSrpUrlActivityListeners();
});
